<template>
  <div class="systemuserlist-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('xl')">
        <el-col :span="8">
          <el-form-item :label="$t('manage.name65')" prop="tenantId">
            <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" :style="$i18n.locale === 'en' ? 'width:360px' : ''" clearable>
              <el-option v-for="item in tenantOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('manage.name1')" prop="keyword">
            <el-input v-model="queryInfo.keyword" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('manage.name2')" prop="status">
            <el-select v-model="queryInfo.status" :placeholder="$t('public.name1')" style="width:130px;">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div>
        <el-button type="primary" size="medium" v-if="buttonPerms.indexOf('user/list') > -1"  @click="getPageList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addUser(1, null)" v-if="buttonPerms.indexOf('user/save') > -1">{{ $t('manage.name3') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('manage.name79')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name4')" prop="loginName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name5')" prop="userName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name6')" prop="roleName" sortable></el-table-column>
      <el-table-column :label="$t('manage.name7')" prop="phone" sortable></el-table-column>
      <el-table-column :label="$t('manage.name8')" prop="email" sortable></el-table-column>
      <el-table-column :label="$t('manage.name9')" prop="updateTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.updateTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name10')" prop="loginDate" sortable width="180px">
        <template slot-scope="scope">
          {{ scope.row.loginDate | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name11')" prop="loginIp" sortable></el-table-column>
      <el-table-column :label="$t('manage.name108')" prop="clientAuth" sortable>
        <template slot-scope="scope">
          <el-switch :value="scope.row.clientAuth.includes('0')"  active-color="#0f73e6" inactive-color="#dcdfe6" @change="changeSwitch(scope.row, $event)"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name12')" prop="status" sortable>
        <template slot-scope="scope">
          <div class="qiyong" v-if="scope.row.status">
            <div class="text">{{ $t('manage.name13') }}</div>
          </div>
          <div class="jinyong" v-else>
            <div class="text">{{ $t('manage.name14') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addUser(2, scope.row)" v-if="buttonPerms.indexOf('user/update') > -1">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="delUser(scope.row)" v-if="buttonPerms.indexOf('user/delete') > -1" style="color:#ea4646">{{ $t('manage.name18') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog width="400px" :title="type === 1 ? $t('manage.name99') : $t('manage.name100')" v-if="userInfoDialog" :visible.sync="userInfoDialog" :before-close="close">
      <el-form ref="userFormRef" :model="userInfo" :rules="type === 1 ? userInfoRules : userInfoRules1" :label-width="formLabelWidth('xl')">
        <el-form-item :label="$t('manage.name65')" prop="tenantId">
          <el-select v-model="userInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%;" @change="changeTenant">
            <el-option v-for="item in tenantOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="loginName" :label="$t('manage.name20')">
          <el-input v-model="userInfo.loginName" :placeholder="$t('public.name5')" :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
        </el-form-item>
        <el-form-item prop="loginPwd" :label="$t('manage.name21')">
          <el-input v-model="userInfo.loginPwd" :placeholder="$t('public.name5')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
        </el-form-item>
        <el-form-item prop="againPwd" :label="$t('public.name26')">
          <el-input v-model="userInfo.againPwd" :placeholder="$t('public.name5')" show-password :readonly="readonlyInput" @focus="cancelReadOnly()"></el-input>
        </el-form-item>
        <el-form-item prop="userName" :label="$t('manage.name22')">
          <el-input v-model="userInfo.userName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="nickName" :label="$t('manage.name23')">
          <el-input v-model="userInfo.nickName" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="phone" :label="$t('manage.name24')">
          <el-input v-model="userInfo.phone" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="email" :label="$t('manage.name26')">
          <el-input v-model="userInfo.email" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="clientAuth" :label="$t('manage.name107')">
          <el-checkbox-group v-model="userInfo.clientAuth"  @change="handleCheckedChange">
            <el-checkbox label="0">{{ $t('manage.name108') }}</el-checkbox>
            <el-checkbox label="1">{{ $t('manage.name125') }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('manage.name25')" prop="roles" v-if="isShowRole">
          <el-select v-model="userInfo.roles" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in rolesOptions" :key="item.roleId +''" :label="item.roleName" :value="item.roleId +''"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" :label="$t('manage.name2')">
          <el-switch v-model="userInfo.status" active-color="#0f73e6" inactive-color="#dcdfe6"> </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { userList, tenantListIdName, userSave, userUpdate, userDelete, sysroleList, updateUserClientAuth } from '@/api/manage.js'
import { validateEmail, validatePass } from '@/utils/utils.js'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    ...mapGetters(['userinfo']),
    statusOptions () {
      return [
        { value: 2, label: this.$t('operate.name98') },
        { value: 0, label: this.$t('operate.name48') },
        { value: 1, label: this.$t('operate.name39') }
      ]
    }
  },
  data() {
    var validateRePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('retrievePassword.name14')))
      } else if (value !== this.userInfo.loginPwd) {
        callback(new Error(this.$t('retrievePassword.name15')))
      } else {
        callback()
      }
    }
    return {
      queryInfo: {
        page: 1,
        limit: 10,
        tenantId: '',
        keyword: '',
        status: 2
      },
      tableLoading: false,
      tenantOptions: [],
      rolesOptions: [],
      tableList: [],
      total: 0,
      selectList: [],
      userInfoRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name476'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        loginPwd: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        againPwd: [
          {
            required: true,
            validator: validateRePass,
            trigger: 'blur'
          }
        ],
        clientAuth: [
          {
            required: true,
            message: this.$t('screen.name24'),
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      userInfoRules1: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name476'),
            trigger: 'blur'
          }
        ],
        loginName: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        clientAuth: [
          {
            required: true,
            message: this.$t('screen.name24'),
            trigger: 'blur'
          }
        ],
        roles: [
          {
            required: true,
            message: this.$t('screen.name25'),
            trigger: 'blur'
          }
        ]
      },
      userInfo: {
        tenantId: '',
        loginName: '',
        loginPwd: '',
        againPwd: '',
        userName: '',
        nickName: '',
        phone: '',
        roles: '',
        email: '',
        status: true,
        tenantType: 1,
        userId: '',
        clientAuth: []
      },
      isShowRole: false,
      userInfoDialog: false,
      type: 1,
      buttonPerms: '',
      readonlyInput: true
    }
  },
  created() {
    this.queryInfo.tenantId = this.$route.query.tenantId
    this.buttonPerms = localStorage.getItem('buttonPerms')
  },
  mounted() {
    this.getTenantListIdName()
    this.queryList()
  },
  methods: {
    cancelReadOnly() {
      this.readonlyInput = false
    },
    getTenantListIdName() {
      tenantListIdName({ tenantType: 1 })
        .then(res => {
          this.tenantOptions = res.data
          if (this.userinfo.tenantType === 1) {
            this.queryInfo.tenantId = this.tenantOptions[0].id
          } else {
            this.userInfo.tenantId = this.queryInfo.tenantId
          }
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
        tenantType: 1
      }
      if (this.queryInfo.keyword) {
        data.keyword = this.queryInfo.keyword.trim()
      }
      if (this.queryInfo.status !== 2) {
        data.status = this.queryInfo.status === 0
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      userList(data)
        .then(res => {
          this.tableList = res.data.list
          this.total = res.data.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },
    delUser(row) {
      this.$confirm(this.$t('manage.name126'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          userDelete({
            id: row.userId + ''
          })
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$t('public.name30')
                })
                this.queryInfo.page = 1
                this.queryList()
              }
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name31')
          })
        })
    },
    handleCheckedChange() {
      this.isShowRole = false
      this.userInfo.clientAuth.map((item) => {
        if (item === '1') {
          this.isShowRole = true
        }
      })
    },
    changeSwitch(row, e) {
      const tip = row.clientAuth.includes('0') ? this.$t('manage.name127') : this.$t('manage.name128')
      this.$confirm(tip, this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      })
        .then(() => {
          this.tableLoading = true
          var clientAuthList = []
          if (row.clientAuth.indexOf('1') > -1) {
            clientAuthList.push(1)
          }
          if (!row.clientAuth.includes('0')) {
            clientAuthList.push(0)
          }
          updateUserClientAuth({ userId: row.userId, clientAuth: clientAuthList.join(',') })
            .then((res) => {
              this.tableLoading = false
              this.queryList()
            })
            .catch(() => {
              this.tableLoading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('public.name34')
          })
        })
    },
    addUser(type, row) {
      this.type = type
      this.isShowRole = false
      if (type === 2) {
        this.userInfo = {
          tenantId: row.tenantId + '',
          loginName: row.loginName,
          loginPwd: '',
          userId: row.userId,
          userName: row.userName,
          nickName: row.nickName,
          phone: row.phone,
          roles: row.roleId,
          email: row.email,
          tenantType: 1,
          status: row.status,
          clientAuth: row.clientAuth.split(',')
        }
        this.userInfo.clientAuth.map((item) => {
          if (item === '1') {
            this.isShowRole = true
          }
        })
        this.getSysroleList(row.tenantId)
      } else {
        if (this.queryInfo.tenantId) {
          this.userInfo.tenantId = this.queryInfo.tenantId
          this.getSysroleList(this.userInfo.tenantId)
        }
      }
      this.userInfoDialog = true
    },

    changeTenant(e) {
      this.getSysroleList(e)
    },

    getSysroleList(tenantId) {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 1,
        tenantId: tenantId
      }
      sysroleList(data)
        .then(res => {
          this.rolesOptions = res.data.list
        })
        .catch(() => {})
    },
    close() {
      this.userInfoDialog = false
      this.userInfo = {
        tenantId: '',
        loginName: '',
        loginPwd: '',
        userId: '',
        userName: '',
        nickName: '',
        phone: '',
        roles: '',
        email: '',
        tenantType: 1,
        status: true,
        clientAuth: []
      }
    },
    submitForm() {
      this.$refs.userFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        if (Array.isArray(this.userInfo.clientAuth)) {
          this.userInfo.clientAuth = this.userInfo.clientAuth.join(',')
        }
        if (this.userInfo.userId) {
          userUpdate(this.userInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.close()
                this.queryInfo.page = 1
                this.queryList()
              } else {
                this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              }
            })
            .catch(() => {
              this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              this.loading = false
            })
        } else {
          userSave(this.userInfo)
            .then(res => {
              if (res.code === 200) {
                this.loading = false
                this.queryInfo.page = 1
                this.close()
                this.queryList()
              } else {
                this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              }
            })
            .catch(() => {
              this.userInfo.clientAuth = this.userInfo.clientAuth.split(',')
              this.loading = false
            })
        }
      })
    },
    resetQuery() {
      this.queryInfo = {
        page: 1,
        limit: 10,
        tenantId: '',
        keyword: '',
        status: 2
      }
      this.queryList()
    },

    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss" scoped>
.systemuserlist-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;

    // Keep controls flush after labels; space between search items (Permissions-like)
    ::v-deep .el-form-item__label {
      width: auto !important;
      padding-right: 8px;
      justify-content: flex-start !important;
      text-align: left !important;
    }

    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }

    ::v-deep .el-col {
      padding-right: 32px;
      box-sizing: border-box;
    }

    ::v-deep .el-col:last-child {
      padding-right: 0;
    }
  }

  .qiyong {
    width: 75px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #39ab4c;
      margin-right: 5px;
    }
  }

  .jinyong {
    width: 75px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;

    .text:before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 2px;
      background: #ea4646;
      margin-right: 5px;
    }
  }
}
</style>
